import { UserGroupIcon } from "@heroicons/react/24/outline";
import ButtonWithConfirm from "../../../components/ButtonWithConfirm";
import { AlertLevel } from "../../../components/AlertMessage";

interface DefaultGroupsButtonProps {
	disabled: boolean;
	onClick: () => void;
}
export function DefaultGroupsButton(props: DefaultGroupsButtonProps) {
	const handleClick = () => {
		props.onClick();
	};

	return (
		<ButtonWithConfirm
			id="use-default-groups-button"
			className="btn btn-neutral mr-2"
			disabled={props.disabled}
			message="Are you sure you want to use the default groups for the course? This will override the groups you currently have set up for the prompt."
			type={AlertLevel.Warning}
			confirmLabel="Yes"
			cancelLabel="No"
			onConfirm={handleClick}>
			<UserGroupIcon className="h-4 inline mr-2" />
			Default Groups
		</ButtonWithConfirm>
	);
}
